import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Dashboard, CreateUpdateDashboardModel } from '../../../domain/models/dashboard';
import * as _ from 'lodash';
import { TranslateService } from 'ng2-translate';
import { Language } from '../../../domain/enums/language';

@Component({
  selector: 'app-create-dashboard',
  templateUrl: './create-dashboard.component.html',
  styleUrls: ['./create-dashboard.component.scss']
})
export class CreateDashboardComponent implements OnInit {
  @Output() public onCreateDashboard: EventEmitter<CreateUpdateDashboardModel>;
  @Output() public onCancel: EventEmitter<void>;
  @ViewChild('logo') logo: any;

  public dashboard: Dashboard;
  public createDashboardForm: FormGroup;
  public readonly minAlternatingInterval = 1;
  public languages = ['NL', 'EN', 'ES', 'FR'];
  public whiteLogoBackground: any;
  public imagePreview: any;

  private newDash: CreateUpdateDashboardModel;
  private formLocked: boolean;
  private logoTooLarge: boolean;

  constructor(private translateService: TranslateService) {
    this.onCreateDashboard = new EventEmitter<CreateUpdateDashboardModel>();
    this.onCancel = new EventEmitter<void>();
  }

  ngOnInit() {
    this.formLocked = false;
    this.dashboard = new Dashboard();
    this.dashboard.language = Language[this.translateService.currentLang.toUpperCase()];
    this.createDashboardForm = this.getFormGroup();
    this.whiteLogoBackground = 0;
    this.newDash = new CreateUpdateDashboardModel();
    this.logoTooLarge = false;
  }

  formIsInvalid(): boolean {
    return this.createDashboardForm.invalid || this.logoTooLarge;
  }

  createDashboard(): void {
    if (!this.formLocked) {
      this.formLocked = true;

      this.newDash = new CreateUpdateDashboardModel();
      this.newDash.name = this.dashboard.name;
      this.newDash.url = this.dashboard.url;
      this.newDash.language = this.dashboard.language;
      this.newDash.jobs = this.dashboard.jobs;
      this.newDash.alernatingInterval = this.dashboard.alernatingInterval;
      this.newDash.fitBoundsToHighlightedRoute = this.dashboard.fitBoundsToHighlightedRoute;
      this.newDash.whiteLogoBackground = this.whiteLogoBackground == 1; // tslint:disable-line:triple-equals
      if (this.logo && this.logo.nativeElement.files && this.logo.nativeElement.files.length > 0) {
        this.handleFiles(this.logo.nativeElement.files[0], true);
      } else {
        this.onCreateDashboard.emit(this.newDash);
      }
    }
  }

  hasLogo(): boolean {
    return this.imagePreview !== undefined;
  }
  previewLogo(): void {
    this.handleFiles(this.logo.nativeElement.files[0], false);
  }
  getLogo(): string {
    return this.imagePreview;
  }
  isWhiteLogoBackground(): boolean {
    return this.whiteLogoBackground == 1; // tslint:disable-line:triple-equals
  }

  clearFilePicker(): void {
    this.logo.nativeElement.value = '';
    this.newDash.Base64 = undefined;
    this.imagePreview = undefined;
    this.logoTooLarge = false;
  }

  private handleFiles(file: any, submit: boolean): void {
    if (file.size > 209715) {
      this.logoTooLarge = true;
    } else {
      this.logoTooLarge = false;
      let img = document.createElement('img');
      img.classList.add('obj');
      let reader = new FileReader();

      reader.onload = ((aImg) => {
        return (e) => {
          aImg.src = e.target.result;
          this.imagePreview = aImg.src;
          let srcArray = aImg.src.split(',');
          this.newDash.Base64 = srcArray[1];
          if (submit) {
            this.submitDashboard();
          }
        };
      })(img);

      reader.readAsDataURL(file);
    }
  }
  private submitDashboard(): void {
    this.onCreateDashboard.emit(this.newDash);
  }

  cancel(): void {
    this.onCancel.emit();
  }

  private getFormGroup(): FormGroup {
    return new FormGroup({
      name: new FormControl({ value: this.dashboard.name }, Validators.required),
      alternatingInterval: new FormControl({ value: this.dashboard.alernatingInterval }, [Validators.required, Validators.min(this.minAlternatingInterval)]),
      language: new FormControl({ value: this.dashboard.language }, Validators.required)
    });
  }

  toEnum(lng: string): Language {
    return Language[lng];
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard-overview/components/create-dashboard/create-dashboard.component.ts